module.exports = __webpack_public_path__ + "img/vignettes-asso_eiffel.ef47f63d.jpg";